"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentRequestEnquiryResponseDtoStatusEnum = exports.DocumentRequestEnquiryResponseDtoEnquiryTypeEnum = void 0;
exports.instanceOfDocumentRequestEnquiryResponseDto = instanceOfDocumentRequestEnquiryResponseDto;
exports.DocumentRequestEnquiryResponseDtoFromJSON = DocumentRequestEnquiryResponseDtoFromJSON;
exports.DocumentRequestEnquiryResponseDtoFromJSONTyped = DocumentRequestEnquiryResponseDtoFromJSONTyped;
exports.DocumentRequestEnquiryResponseDtoToJSON = DocumentRequestEnquiryResponseDtoToJSON;
exports.DocumentRequestEnquiryResponseDtoToJSONTyped = DocumentRequestEnquiryResponseDtoToJSONTyped;
var DocumentRequestMediaDto_1 = require("./DocumentRequestMediaDto");
/**
 * @export
 */
exports.DocumentRequestEnquiryResponseDtoEnquiryTypeEnum = {
    Inspection: 'inspection',
    DocumentRequest: 'document_request',
    GeneralEnquiry: 'general_enquiry',
    ListingCrmEnquiry: 'listing_crm_enquiry',
    PropertyValuation: 'property_valuation',
    ListProperty: 'list_property'
};
/**
 * @export
 */
exports.DocumentRequestEnquiryResponseDtoStatusEnum = {
    InProgress: 'in_progress',
    Open: 'open',
    Resolved: 'resolved'
};
/**
 * Check if a given object implements the DocumentRequestEnquiryResponseDto interface.
 */
function instanceOfDocumentRequestEnquiryResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('enquiryType' in value) || value['enquiryType'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('media' in value) || value['media'] === undefined)
        return false;
    if (!('isBAndPInspectionRequired' in value) || value['isBAndPInspectionRequired'] === undefined)
        return false;
    return true;
}
function DocumentRequestEnquiryResponseDtoFromJSON(json) {
    return DocumentRequestEnquiryResponseDtoFromJSONTyped(json, false);
}
function DocumentRequestEnquiryResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'enquiryId': json['enquiryId'],
        'enquiryType': json['enquiryType'],
        'userId': json['userId'],
        'receiverId': json['receiverId'] == null ? undefined : json['receiverId'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'email': json['email'],
        'listingId': json['listingId'],
        'media': (json['media'].map(DocumentRequestMediaDto_1.DocumentRequestMediaDtoFromJSON)),
        'isBAndPInspectionRequired': json['isBAndPInspectionRequired'],
    };
}
function DocumentRequestEnquiryResponseDtoToJSON(json) {
    return DocumentRequestEnquiryResponseDtoToJSONTyped(json, false);
}
function DocumentRequestEnquiryResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'enquiryId': value['enquiryId'],
        'enquiryType': value['enquiryType'],
        'userId': value['userId'],
        'receiverId': value['receiverId'],
        'status': value['status'],
        'createdAt': value['createdAt'].toISOString(),
        'email': value['email'],
        'listingId': value['listingId'],
        'media': (value['media'].map(DocumentRequestMediaDto_1.DocumentRequestMediaDtoToJSON)),
        'isBAndPInspectionRequired': value['isBAndPInspectionRequired'],
    };
}
